import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SharedService } from '../../../shared/services/shared.service';

@Component({
  selector: 'app-un-authorized',
  standalone: true,
  imports: [CommonModule, ButtonComponent, TranslateModule],
  templateUrl: './un-authorized.component.html',
  styleUrl: './un-authorized.component.scss'
})
export class UnAuthorizedComponent {
  private readonly fallbackLang = 'en';
  constructor(
    private router: Router,
    private translate: TranslateService,
    private sharedService: SharedService
  ) {
    const lang = this.resolveLang();
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);

    if(!this.sharedService.getUserProfile()){
        this.goToLogin();
    }
  }
  // This method is used to go to login
  goToLogin() {
    const lang = this.resolveLang();
    sessionStorage.clear();
    localStorage.clear();
    // Restore language
    localStorage.setItem("selectedLang", lang);
    setTimeout(() => {
      this.router.navigate(["/login"]);
    }, 3000);
  }

  // This method is used to go home
  goHome() {
    this.router.navigate(['/']);
  }

  private resolveLang(): string {
    const currentLang = (this.translate.currentLang || '').toLowerCase();
    const storedLang = (this.sharedService.getCurrentLang() || '').toLowerCase();
    if (storedLang === 'ar' || storedLang === 'en') {
      return storedLang;
    }
    if (currentLang === 'ar' || currentLang === 'en') {
      return currentLang;
    }
    return this.fallbackLang;
  }
}
